<template>
  <svg viewBox="0 0 160 220" overflow="visible" aria-hidden="true">
    <defs>
      <radialGradient id="hk-lamp-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0" stop-color="#F2B98F" stop-opacity=".55" />
        <stop offset="1" stop-color="#F2B98F" stop-opacity="0" />
      </radialGradient>
    </defs>
    <circle cx="80" cy="132" r="78" fill="url(#hk-lamp-glow)" />
    <path d="M80 -600v686" stroke="#A9C4A5" stroke-width="2.5" />
    <rect x="73" y="80" width="14" height="10" rx="3" fill="#C26A35" />
    <path d="M44 124c0-22 16-36 36-36s36 14 36 36Z" fill="#E0915F" />
    <rect x="40" y="121" width="80" height="7" rx="3.5" fill="#C26A35" />
    <circle cx="80" cy="134" r="9" fill="#FFE8CF" />
  </svg>
</template>

<script>
export default {
  name: "IlloLamp",
};
</script>
